import { CssBaseline } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Header from '../pages/Header';
import Box from '@mui/material/Box';
import Chip from '@material-ui/core/Chip';
import Accordion from '@mui/material/Accordion';
import JSZip from "jszip";
import axios from "axios";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FormControl from '@material-ui/core/FormControl';
import {
    Card,
    CardContent,
    Typography,
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    Dialog,
    CircularProgress,
    DialogContent,
    DialogActions,
    DialogTitle,
} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Drop from '../components/drop';
import Autocomplete from '@material-ui/lab/Autocomplete';


const AhriUpload = ({ fetchAPI, flag, classes, username }) => {
    const isSalesGroup = flag;
    const [fileObjects, setfileObjects] = useState([]);
    const [showFilters, setShowFilters] = useState(false);

    // Default values for dropdowns
    const programOptions = ['USAC', 'USHP', 'USACUSHP', 'VSMSAC', 'VSMSHP', 'VSMSACVSMSHP'];
    const actionOptions = ['Add', 'Edit'];
    const licenseeOptions = ['OEM', 'PBM'];
    const manufacturerOptions = ['Systems', 'Systems - M1', 'Coil(Mix-Match)', 'Coil(Mix-Match) - M1'];
    const programTypeOptions = ['USAC', 'USHP'];
    
    // Constraint Type Options dropdown
    const constraintTypeOptions = ['='];
    
    // OEM Filter Options for USAC
    const oemFilterOptionsUSAC = {
        "AHRI Certified Reference Number": "ReferenceId",
        "Model Status": "modelStatus",
        "Brand Name": "brandName",
        "Test Locked": "isLocked",
        "Basic Model Group Id": "basicModelGroupID",
        "Manufacturer Type": "manufacturertype",
        "Outdoor Unit Manufacturer's AHRI Reference Number": "outdoorManufacturerReferenceNumber",
        "Sold in?": "soldIn",
        "AHRI Type": "aHRIType",
        "Type of Air Conditioner or Heat Pump Associated with the Minimum External Static Pressure Used in Testing or Rating": "airConditionerOrHeatPumpM1",
        "Series Name": "seriesName",
        "Manufacturer Name": "manufacturerName",
        "Basic Model": "basicModelInd",
        "Outdoor Unit Model Number  (Condenser or Single Package)": "modelNumber",
        "Basic Model Number": "basicModelNumber",
        "Indoor Unit Model Number (Evaporator and/or Air Handler)": "coilModelNumber",
        "Furnace Model Number": "furnaceModelNumber",
        "Rating Conditions": "ratingConditions",
        "International Rating Conditions to be Certified": "internationalRatingConditionsCertified",
        "Alternate SASO Registration Point": "alternateSASORegistrationPoint",
        "Air Handler Manufacturer": "airHandlerManufacturer",
        "Dual Condenser?": "dualCondenser",
        "Orifice Size": "orificeSize",
        "Liquid Line OD": "liquidLineOD",
        "Vapor Line OD": "vaporLineOD",
        "Indoor Time Delay": "indoorTimeDelay",
        "Duration of the Indoor Fan Time Delay (Seconds)  if Used": "durationoftheIndoorFanTimeDelay",
        "Outdoor Unit Nominal Capacity": "outdoorUnitNominalCapacity",
        "Cooling Capacity (A2) - Single or High Stage (95F)": "capacity95FHigh",
        "Cooling Capacity (AFull) - Single or High Stage (95F)  btuh": "capacity95FHighM1",
        "Cooling Capacity (Ev) - Intermediate Stage (87F)": "capacity95FInter",
        "EER (A2) - Single or High Stage (95F)": "eER95F",
        "EER2 (AFull) - Single or High Stage (95F)": "eER95FM1",
        "IEER": "iEER",
        "EER (Ev) - Intermediate Stage (87F)": "eER87F",
        "Cooling Capacity (B2) - Single or High Stage (82F)": "capacity82FHigh",
        "EER (B2) - Single or High Stage (82F)": "eER82F",
        "SEER": "sEER",
        "SEER2": "sEERM1",
        "Average Off Mode Power Consumption (W)": "averageOffModePowerConsumption",
        "Is the Average Off Mode Power Consumption Rating Based on Testing of This Combination?": "istheAverageOffModePowerConsumptionRatingBasedonTestingofThisCombination",
        "Degradation Coefficient Cooling": "degreeCoeffCool",
        "Were the Optional Tests Conducted to Determine Cooling Cd value?": "weretheOptionalTestsConductedtoDetermineCoolingCdvalue",
        "Indoor Full-Load Air Volume Rate (A2 SCFM)": "indoorCoilAirQty",
        "Which Indoor Fans operating at Full Load (A2 SCFM)": "whichIndoorFansoperatingatFullLoadA2SCFM",
        "Allocated Air Flow for Fan 1 (A2 SCFM)": "allocatedAirFlowforFan1A2SCFM",
        "Allocated Air Flow for Fan 2 (A2 SCFM)": "allocatedAirFlowforFan2A2SCFM",
        "Airflow-Control Settings Instructions to Achieve Full-Load Cooling (A2 SCFM)": "airflowControlSettingsInstructionstoAchieveFullLoadCoolingA2SCFM",
        "Airflow-Control Settings Full-Load Cooling (A2 SCFM)": "airflowControlSettingsFullLoadCoolingA2SCFM",
        "Which Indoor Fans operating at Intermediate Air Volume Rate (Ev SCFM)": "whichIndoorFansoperatingatIntermediateAirVolumeRateEvSCFM",
        "Indoor Cooling Intermediate Air Volume Rate (Ev SCFM)": "indoorCoilAirQty2",
        "Allocated Air Volume Rate for Fan 1 (Ev SCFM)": "allocatedAirVolumeRateforFan1EvSCFM",
        "Allocated Air Volume Rate for Fan 2 (Ev SCFM)": "allocatedAirVolumeRateforFan2EvSCFM",
        "Airflow-Control Settings Intermediate Cooling (Ev SCFM)": "airflowControlSettingsIntermediateCoolingEvSCFM",
        "Airflow-Control Settings Instructions to Achieve Intermediate Cooling (Ev SCFM)": "airflowControlSettingsInstructionstoAchieveFullLoadCoolingEvSCFM",
        "Which Indoor Fans operating at Minimum Air Volume Rate (B1 SCFM)": "whichIndoorFansoperatingatMinimumAirVolumeRateB1SCFM",
        "Indoor Cooling Minimum Air Volume Rate (B1 SCFM)": "indoorCoilAirQty3",
        "Allocated Air Volume Rate for Fan 1 (B1 SCFM)": "allocatedAirVolumeRateforFan1B1SCFM",
        "Allocated Air Volume Rate for Fan 2 (B1 SCFM)": "allocatedAirVolumeRateforFan2B1SCFM",
        "Airflow-Control Settings Minimum Cooling (B1 SCFM)": "airflowControlSettingsMinimumCoolingB1SCFM",
        "Airflow-Control Settings Instructions to Achieve Minimum Cooling (B1 SCFM)": "airflowControlSettingsInstructionstoAchieveMinimumCoolingB1SCFM",
        "Total Cooling Full Load Air Volume Rate (SCFM)": "totalCoolingFullLoadAirVolumeRateM1",
        "Indoor Unit Orientation": "indoorUnitOrientation",
        "Is there a Crankcase Heater?": "isthereaCrankcaseHeater",
        "Crankcase Heater Control Affected by Crankcase Heater?": "crankcaseHeaterControlAffectedbyCrankcaseHeater",
        "Temperature at Which the Crankcase Heater with Controls is Designed to Turn On": "temperatureatWhichtheCrankcaseHeaterwithControlsisDesignedtoTurnOn",
        "A2 Compressor Frequency/Speed": "a2CompressorFrequencySpeed",
        "A2 Required Dip Switch/Control Settings for Step or Variable Components": "a2RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "B2 Compressor Frequency/Speed": "b2CompressorFrequencySpeed",
        "B2 Required Dip Switch/Control Settings for Step or Variable Components": "b2RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "EV Compressor Frequency/Speed": "eVCompressorFrequencySpeed",
        "EV Required Dip Switch/Control Settings for Step or Variable Components": "eVRequiredDipSwitchControlSettingsforSteporVariableComponents",
        "B1 Compressor Frequency/Speed": "b1CompressorFrequencySpeed",
        "B1 Required Dip Switch/Control Settings for Step or Variable Components": "b1RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "F1 Compressor Frequency/Speed": "f1CompressorFrequencySpeed",
        "F1 Required Dip Switch/Control Settings for Step or Variable Components": "f1RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "G1 Compressor Frequency/Speed": "g1CompressorFrequencySpeed",
        "G1 Required Dip Switch/Control Settings for Step or Variable Components": "g1RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "I1 Compressor Frequency/Speed": "i1CompressorFrequencySpeed",
        "I1 Required Dip Switch/Control Settings for Step or Variable Components": "i1RequiredDipSwitchControlSettingsforSteporVariableComponents",
        "Enter Any Other Type of Step or Variable Component(s)": "enterAnyOtherTypeofSteporVariableComponents",
        "For the Component(s) Identified in the Previous Column  Enter the Required Dip Switch/Control Setting(s) Used for Testing": "fortheComponentsIdentifiedinPreviousColumns",
        "Designated Tested Combination": "isHSVTC",
        "Sold in California": "soldInCAState",
        "Capacity at 105F (Btuh)": "capacity105F",
        "EER @ 105F": "eER105F",
        "Capacity at 115F (Btuh)": "capacity115F",
        "EER @ 115": "eER115F",
        "Break-in Period (hrs.)": "breakIn",
        "Certification Based on Waiver of DOE's Test Procedure Requirements?": "testWaiver",
        "Date of Test Procedure Waiver": "testWaiverDate",
        "Certification based on  Exception Relief granted by DOE's Office?": "exceptionRelief",
        "Date of Exception Relief": "exceptionReliefDate",
        "Certification based on an Alternate Way of Determining Measures of Energy Conservation?": "alternateMethod",
        "AEDM Name or Identifier": "aedmName",
        "M1 Certification based on an Alternate Way of Determining Measures of Energy Conservation?": "alternateMethodM1",
        "M1 AEDM Name or Identifier": "aedmNameM1",
        "Sample Size": "sampleSize",
        "M1 Sample Size": "sampleSizeM1",
        "Is basic model engineered-to-order?": "engToOrder",
        "Witness test option for DOE": "witnessOptionDoe",
        "Was an Inlet Plenum Installed During Testing?": "wasanInletPlenumInstalledDuringTesting",
        "US Customs and Border Protection importer ID number": "uSCustomsBorderIDnumber",
        "Is this an Outdoor Unit with No Match (OUWNM)?": "isthisanOutdoorUnitwithNoMatchOUWNM",
        "Number of Tubes High": "numberofTubesHigh",
        "Number of Tubes Deep": "numberofTubesDeep",
        "Does this Central Air Conditioners or Heat Pumps have Two-Capacity Compressors that Lock Out Low Capacity Operation for Cooling at Higher Outdoor Temperatures?": "doesthisCentralAirConditionersorHeatPumpshaveTwoCapacityCompressors",
        "For Central Air Conditioners and Heat Pumps that have Two-Capacity Compressors that Lock Out Low Capacity Operation for Cooling at Higher Outdoor Temperatures  Enter the Outdoor Temperature at Which the Unit Locks Out Low Capacity Operation (Degrees F)": "forCentralAirConditionersandHeatPumpsthathaveTwoCapacityCompressorsforCooling",
        "Coil Depth in the Direction of Airflow (Inches)": "coilDepthInDirectionofAirflowInches",
        "Manufacturer Comments": "mfrComments",
        "Submit to Energy Star": "submittoEnergyStar",
        "ENERGY STAR Manufacturing Partner's EPA-issued Organization ID": "eNERGYSTARManufacturing",
        "Partner Contact Name for This Model": "partnerContactName",
        "Laboratory's EPA-issued Organization ID": "laboratorysEPA",
        "Laboratory Contact for this Model": "laboratoryContact",
        "Date Available on Market": "dateAvailableonMarket",
        "In What Markets Is this Model Sold?": "modelSold",
        "Cooling Capacity at T1": "coolingCapacityAtT1",
        "Cooling Capacity at T2": "coolingCapacityAtT2",
        "Cooling Capacity at T3": "coolingCapacityAtT3",
        "EER at T1": "eERAtT1",
        "EER at T2": "eERAtT2",
        "EER at T3": "eERAtT3",
        "Rated Full Load Indoor Coil Air Quantity at T1": "ratedFullLoadIndoorCoilAirQuantityAtT1",
        "Rated Full Load Indoor Coil Air Quantity at T2": "ratedFullLoadIndoorCoilAirQuantityAtT2",
        "Rated Full Load Indoor Coil Air Quantity at T3": "ratedFullLoadIndoorCoilAirQuantityAtT3",
        "Extra High Conditions Operability": "extraHighConditionsOperability",
        "Publication of Appendix M1 data": "publicationOfAppendixM1",
        "Date of Appendix M1 publication": "dateOfAppendixM1PublicationM1",
        "Heating Section Type": "heatingSectionType",
        "Phase": "cEEPhaseUSACHP",
        "Region": "searchRegion",
        "Labeled ENERGY STAR?": "isEnergyStarApprovedbyAHRI",
        "Footnotes": "footnotes",
        "Comments": "comments",
        "Energy Star Withdrawal Comments": "energyStarWithdrawalComments",
        "Discontinued Reason": "discontinuedReason",
        "Discontinued Date": "discontinuedDate",
        "Location": "locationName",
        "Is Hidden": "isHidden",
        "Created Date": "createdDate",
        "Created By": "createdBy",
        "Modified Date": "modifiedDate",
        "Modified By": "modifiedBy",
        "ProductionStop Date": "productionStopDate",
        "Is Rerated": "isRerated",
        "Rerated Date": "reratedDate",
        "Program": "programName",
        "Company": "companyName",
        "Is Approved": "isApproved",
        "Locked Under EPA Process": "lockedByRole",
        "Outdoor Unit Brand Name": "outdoorUnitBrandName",
        "Old AHRI Reference Number": "oldRefId",
        "Supplemental PDF": "doeHasPdf",
        "Reported to DOE?": "doeIsReported",
        "Last Daily DOE Report Date": "doeLastDailyReportDate",
        "Latest DOE Report Action": "doeLastReportAction",
        "Latest CCMS ID": "doeLastCcmsId",
        "Published?": "isPublished",
        "CEE Tier": "ceeTierName",
        "Cooling Capacity at T4": "coolingCapacityT4",
        "EER at T4": "eERT4",
        "Rated Full Load Indoor Coil Air Quantity at T4": "ratedFullLoadIndoorCoilAirQuantityT4",
        "For Which CEE Demand Response Level (according to Section 4.4 Connected Criteria of the CEE Residential Heating and Cooling Systems Initiative) Does the Model Qualify?": "cEEDemandResponseLevel",
        "Tested Outdoor Model Number": "testedOutdoorModelNumber",
        "Installation Capabilities": "installationCapabilities",
        "Connected Functionality": "connectedFunctionality",
        "Communication Standard - Application Layer": "commStandardApplication",
        "Communication Standard - Media/Network Layer": "commStandardMediaNtwrk",
        "Communication Standard - Media/Network Layer Other": "commStandardMediaNtwrkOther",
        "Communication Hardware Architecture": "commHardwareArchitecture",
        "Primary Communication Module/Device Brand Name": "commDeviceBrandPrimary",
        "Primary Communication Module/Device Model Number": "commDeviceModelNumberPrimary",
        "Features Enabled By Primary Communication Module/Device": "commDeviceFeatureEnbldPrimary",
        "Secondary Communication Module/Device Brand Name": "commDeviceBrandSecondary",
        "Secondary Communication Module/Device Model Number": "commDeviceModelNumberSecondary",
        "Features Enabled By Secondary Communication Module/Device": "commDeviceFeatureEnbldSecondary",
        "Tertiary Communication Module/Device Brand Name": "commDeviceBrandTertiary",
        "Tertiary Communication Module/Device Model Number": "commDeviceModelNumberTertiary",
        "Features Enabled By Tertiary Communication Module/Device": "commDeviceFeatureEnbldTertiary",
        "Is Broadband Internet Connection Needed for Demand Response?": "isBroadbandNeeded",
        "Model Name": "ModelName",
        "Tested Model Name": "testedModelName",
        "Tested Indoor Model Number": "testedModelNumber",
        "Date Tested": "TestedDate",
        "Old Basic Model Group Id": "oldBasicModelGroupID",
        "In what countries should this record be considered for Path A compliance?": "pathAComplianceCountries",
        "Refrigerant Type": "refrigerantTypeCharacteristics",
        "Manufacturer Reference Number": "manufacturerReferenceNumber",
        "For Variable-Speed Coil-Only Systems Only  Is the Represented Value Based on Non-Communicating or Communicating Control?": "variableSpeedCoilOnlySystemsRepresentedValue",
        "Does the System Vary Blower Speeds with Outdoor Air Conditions?": "doesSystemVaryBlowerSpeedsWithOutdoorAirConditions",
        "Would you like to submit optional data to DOE for Tax Credit Evaluation?": "submitOptionalDataToDOEforTaxCreditEvaluation",
        "Demand Response - Ready HVAC System?": "demandResponseReadyHVACSystem",
        "Is AHRI 1380 Basic Model?": "isAHRI1380BasicModel",
        "AHRI 1380 Basic Model Number": "aHRI1380BasicModelNumber",
        "Demand Response-Ready HVAC System Model Number": "demandResponseReadyHVACSystemModelNumber",
        "Cooling Rated Load Power": "coolingRatedLoadPower",
        "Demand Response - Communication Protocol(s) Supported": "demandResponseCommunicationProtocolSupported",
        "Form Factor Type if CTA-2045-A is the Demand Response - Communication Protocol": "formFactorTypeIfCTA2045AisDRCommunicationProtocol"
    };

    // PBM Filter Options for USAC
    const pbmFilterOptionsUSAC = {
        "AHRI Certified Reference Number": "referenceId",
        "Status": "modelStatus",
        "Brand": "brandName",
        "Test Locked": "isLocked",
        "Manufacturer Type": "manufacturertype",
        "PBM Outdoor Unit Model Number (Condenser or Single Package)": "modelNumber",
        "PBM Indoor Unit Model Number (Evaporator and/or Air Handler)": "coilModelNumber",
        "Furnace Model Number": "furnaceModelNumber",
        "Is Rerated": "isRerated",
        "Locked Under EPA Process": "lockedByRole"
    };

    // OEM Filter Options for USHP
    const oemFilterOptionsUSHP = {
        "AHRI Certified Reference Number": "ReferenceId",
        "Model Status": "ModelStatus",
        "Brand Name": "BrandName",
        "Test Locked": "IsLocked",
        "Basic Model Group Id": "BasicModelGroupID",
        "Manufacturer Type": "manufacturertype",
        "Outdoor Unit Manufacturer's AHRI Reference Number": "OutdoorManufacturerReferenceNumber",
        "Sold in?": "SoldInUSHP",
        "AHRI Type": "ARITypeidUSHP",
        "Type of Air Conditioner or Heat Pump Associated with the Minimum External Static Pressure Used in Testing or Rating": "AirConditionerOrHeatPumpM1",
        "Series Name": "SeriesName",
        "Manufacturer Name": "ManufacturerName",
        "Basic Model": "BasicModelInd",
        "Outdoor Unit Model Number (Condenser or Single Package)": "ModelNumberUSHP",
        "Basic Model Number": "BasicModelNumber",
        "Indoor Unit Model Number (Evaporator and/or Air Handler)": "CoilModelNumberUSHP",
        "Furnace Model Number": "FurnaceModelNumberUSHP",
        "Rating Conditions": "RatingConditionsUSHP",
        "International Rating Conditions to be Certified": "InternationalRatingConditionstobeCertifiedUSHP",
        "Alternate SASO Registration Point": "AlternateSASORegistrationPoint",
        "Dual Condenser?": "UsesDualCondenser",
        "Orifice Size": "OrificeSize",
        "Vapor Line OD": "VaporLineOD",
        "Liquid Line OD": "LiquidLineOD",
        "Indoor Time Delay": "IndoorTimeDelay",
        "Duration of the Indoor Fan Time Delay (Seconds) if Used": "DurationoftheIndoorFanTimeDelayifUsedUSHP",
        "Cooling Capacity (A2) - Single or High Stage (95F)": "Capacity95FHighM1",
        "Cooling Capacity (AFull) - Single or High Stage (95F), btuh": "Capacity95FHigh",
        "Heating Capacity (H1Nom) - Multi/Variable Stage (47F)": "OutdoorUnitNominalCapacityUSHP",
        "Cooling Capacity (Ev) - Intermediate Stage (87F)": "Capacity95FInter",
        "EER (A2) - Single or High Stage (95F)": "EER95F",
        "EER2 (AFull) - Single or High Stage (95F)": "EER95FM1",
        "EER (Ev) - Intermediate Stage (87F)": "EER87F",
        "Cooling Capacity (B2) - Single or High Stage (82F)": "Capacity82FHigh",
        "EER (B2) - Single or High Stage (82F)": "EER82F",
        "SEER": "SEER",
        "SEER2": "SEERM1",
        "Is the Average Off Mode Power Consumption Rating Based on Testing of This Combination?": "IstheAverageOffModePowerConsumptionRatingBasedonTestingofThisCombinationUSHP",
        "Average Off Mode Power Consumption (W)": "AverageOffModePowerConsumptionUSHP",
        "Degradation Coefficient Cooling": "DegreeCoeffCool",
        "Were the Optional Tests Conducted to Determine Cooling Cd value?": "WeretheOptionalTestsConductedtoDetermineCoolingCdvalueUSHP",
        "Indoor Full-Load Air Volume Rate (A2 SCFM)": "IndoorCoilAirQty",
        "Which Indoor Fans operating at Full Load (A2 SCFM)": "WhichIndoorFansoperatingatFullLoadA2SCFMUSHP",
        "Allocated Air Flow for Fan 1 (A2 SCFM)": "AllocatedAirFlowforFan1A2SCFMUSHP",
        "Allocated Air Flow for Fan 2 (A2 SCFM)": "AllocatedAirFlowforFan2A2SCFMUSHP",
        "Airflow-Control Settings Full-Load Cooling (A2 SCFM)": "AirflowControlSettingsFullLoadCoolingA2SCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Full-Load Cooling (A2 SCFM)": "AirflowControlSettingsInstructionstoAchieveFullLoadCoolingA2SCFMUSHP",
        "Indoor Cooling Intermediate Air Volume Rate (Ev SCFM)": "IndoorCoilAirQty2",
        "Which Indoor Fans operating at Intermediate Air Volume Rate (Ev SCFM)": "WhichIndoorFansoperatingatIntermediateAirVolumeRateEvSCFMUSHP",
        "Allocated Air Volume Rate for Fan 1 (Ev SCFM)": "AllocatedAirVolumeRateforFan1EvSCFMUSHP",
        "Allocated Air Volume Rate for Fan 2 (Ev SCFM)": "AllocatedAirVolumeRateforFan2EvSCFMUSHP",
        "Airflow-Control Settings Intermediate Cooling (Ev SCFM)": "AirflowControlSettingsIntermediateCoolingEvSCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Intermediate Cooling (Ev SCFM)": "AirflowControlSettingsInstructionstoAchieveFullLoadCoolingEvSCFMUSHP",
        "Indoor Cooling Minimum Air Volume Rate (B1 SCFM)": "IndoorCoilAirQty3",
        "Which Indoor Fans operating at Minimum Air Volume Rate (B1 SCFM)": "WhichIndoorFansoperatingatMinimumAirVolumeRateB1SCFMUSHP",
        "Allocated Air Volume Rate for Fan 1 (B1 SCFM)": "AllocatedAirVolumeRateforFan1B1SCFMUSHP",
        "Allocated Air Volume Rate for Fan 2 (B1 SCFM)": "AllocatedAirVolumeRateforFan2B1SCFMUSHP",
        "Airflow-Control Settings Minimum Cooling (B1 SCFM)": "AirflowControlSettingsMinimumCoolingB1SCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Minimum Cooling (B1 SCFM)": "AirflowControlSettingsInstructionstoAchieveMinimumCoolingB1SCFMUSHP",
        "Total Cooling Full Load Air Volume Rate (SCFM)": "TotalCoolingFullLoadAirVolumeRateM1",
        "Heating Capacity (H12) - Single or High Stage (47F)": "HighHeat47F",
        "Heating Capacity (H1Full) - Single or High Stage (47F), btuh": "HighHeat47FM1",
        "Indoor Unit Orientation": "IndoorUnitOrientationUSHP",
        "Heating COP (H1Full) - Single or High Stage (47F)": "HighCOP47F",
        "HSPF (Region IV)": "HSPF",
        "HSPF2 (Region IV)": "HSPFM1",
        "Degradation Coefficient Heating": "DegCoeffHeat",
        "Were the Optional Tests Conducted to Determine Heating Cd value?": "WeretheOptionalTestsConductedtoDetermineHeatingCdvalueUSHP",
        "Heating Capacity (H32) - Single or High Stage (17F)": "LowHeat17F",
        "Heating COP (H32) - Single or High Stage (17F)": "LowCOP17F",
        "Demand Defrost": "DemandsDefrost",
        "Maximum Time Between Defrosts as Allowed by the Controls (in hours)": "MaximumTimeBetweenDefrostsasAllowedbytheControlsinhoursUSHP",
        "Time-Adaptive Defrost Control": "TimeAdaptiveDefrostControlUSHP",
        "Frosting Interval to be Used During Frost Accumulation Tests": "FrostingIntervaltobeUsedDuringFrostAccumulationTestsUSHP",
        "Procedure for Manually Initiating the Defrost at the Specified Time": "ProcedureforManuallyInitiatingtheDefrostattheSpecifiedTimeUSHP",
        "Is this a Triple-Capacity Northern Heat Pump?": "TripleCapacityNorthernHeatPumpM1",
        "Was Optional 5 Degree F Very Low Temperature Heating Mode Test Used to Characterize Performance at Temperatures Below 17 Degrees F?": "TemperatureHeatingModeTestBelow17DegreesFM1",
        "Was Alternative Test Required for Minimum-Speed-Limiting Variable-Speed Heat Pumps Used?": "AlternativeTestReqForMinimumSpeedLimitingVariableM1",
        "Indoor Full-Load Heating Air Volume Rate (H12 SCFM)": "IndoorFullLoadHeatingAirVolumeRateH12SCFMUSHP",
        "Which Indoor Fans operating at Full Load (H12 SCFM)": "WhichIndoorFansoperatingatFullLoadH12SCFMUSHP",
        "Allocated Air Volume Rate for Fan 1 (H12 SCFM)": "AllocatedAirVolumeRateforFan1H12SCFMUSHP",
        "Allocated Air Volume Rate for Fan 2 (H12 SCFM)": "AllocatedAirVolumeRateforFan2H12SCFMUSHP",
        "Airflow-Control Settings Full-Load Heating (H12 SCFM)": "AirflowControlSettingsFullLoadHeatingH12SCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Full-Load Heating (H12 SCFM)": "AirflowControlSettingsInstructionstoAchieveFullLoadHeatingH12SCFMUSHP",
        "Indoor Intermediate Heating Air Volume Rate (H2v SCFM)": "IndoorIntermediateHeatingAirVolumeRateH2vSCFMUSHP",
        "Which Indoor Fans operating at Intermediate (H2v SCFM)": "WhichIndoorFansoperatingatIntermediateH2vSCFMUSHP",
        "Allocated Air Flow for Fan 1 (H2v SCFM)": "AllocatedAirFlowforFan1H2vSCFMUSHP",
        "Allocated Air Flow for Fan 2 (H2v SCFM)": "AllocatedAirFlowforFan2H2vSCFMUSHP",
        "Airflow-Control Settings Intermediate Heating (H2v SCFM)": "AirflowControlSettingsIntermediateHeatingH2vSCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Intermediate Heating (H2v SCFM)": "AirflowControlSettingsInstructionstoAchieveIntermediateHeatingH2vSCFMUSHP",
        "Indoor Minimum Heating Air Volume Rate (H01 SCFM)": "IndoorMinimumHeatingAirVolumeRateH01SCFMUSHP",
        "Which Indoor Fans operating at Minimum (H01 SCFM)": "WhichIndoorFansoperatingatMinimumH01SCFMUSHP",
        "Allocated Air Flow for Fan 1 (H01 SCFM)": "AllocatedAirFlowforFan1H01SCFMUSHP",
        "Allocated Air Flow for Fan 2 (H01 SCFM)": "AllocatedAirFlowforFan2H01SCFMUSHP",
        "Airflow-Control Settings Minimum Heating (H01 SCFM)": "AirflowControlSettingsMinimumHeatingH01SCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Minimum Heating (H01 SCFM)": "AirflowControlSettingsInstructionstoAchieveMinimumHeatingH01SCFMUSHP",
        "Indoor Nominal Heating Air Volume Rate (H1N SCFM)": "IndoorNominalHesatingAirVolumeRateH1NSCFMUSHP",
        "Allocated Air Flow for Fan 1 (H1N SCFM)": "AllocatedAirFlowforFan1H1NSCFMUSHP",
        "Which Indoor Fans operating at Nominal (H1N SCFM)": "WhichIndoorFansoperatingatNominalH1NSCFMUSHP",
        "Allocated Air Flow for Fan 2 (H1N SCFM)": "AllocatedAirFlowforFan2H1NSCFMUSHP",
        "Airflow-Control Settings Nominal Heating (H1N SCFM)": "AirflowControlSettingsNominalHeatingH1NSCFMUSHP",
        "Airflow-Control Settings Instructions to Achieve Nominal Heating (H1N SCFM)": "AirflowControlSettingsInstructionstoAchieveNominalHeatingH1NSCFMUSHP",
        "Is there a Crankcase Heater?": "IsthereaCrankcaseHeaterUSHP",
        "Crankcase Heater Control Affected by Crankcase Heater?": "CrankcaseHeaterControlAffectedbyCrankcaseHeaterUSHP",
        "Temperature at Which the Crankcase Heater with Controls is Designed to Turn On": "TemperatureatWhichtheCrankcaseHeaterwithControlsisDesignedtoTurnOnUSHP",
        "Does the Unit Controls Restrict Use of Minimum Compressor Speed Operation for some Range of Operating Ambient Conditions?": "DoestheUnitControlsRestrictforsomeRangeofOperatingAmbientConditionsUSHP",
        "Does the Unit Controls Restrict Use of Maximum Compressor Speed Operation for any Ambient Temperatures Below 17 Degrees F?": "DoestheUnitControlsRestrictforanyAmbientTemperaturesBelowDegreesFUSHP",
        "Was the Optional H42 Low Temperature Test Used to Characterize Performance at Temperatures Below 17 Degrees F?": "WastheOptionalH42LowTemperatureTestUsedtoCharacterizePerformanceUSHP",
        "A2 Compressor Frequency/Speed": "A2CompressorFrequencySpeedUSHP",
        "B2 Compressor Frequency/Speed": "B2CompressorFrequencySpeedUSHP",
        "A2 Required Dip Switch/Control Settings for Step or Variable Components": "A2RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "B2 Required Dip Switch/Control Settings for Step or Variable Components": "B2RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "EV Compressor Frequency/Speed": "EVCompressorFrequencySpeedUSHP",
        "EV Required Dip Switch/Control Settings for Step or Variable Components": "EVRequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "B1 Compressor Frequency/Speed": "B1CompressorFrequencySpeedUSHP",
        "B1 Required Dip Switch/Control Settings for Step or Variable Components": "B1RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "F1 Compressor Frequency/Speed": "F1CompressorFrequencySpeedUSHP",
        "F1 Required Dip Switch/Control Settings for Step or Variable Components": "F1RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "G1 Compressor Frequency/Speed": "G1CompressorFrequencySpeedUSHP",
        "G1 Required Dip Switch/Control Settings for Step or Variable Components": "G1RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "I1 Compressor Frequency/Speed": "I1CompressorFrequencySpeedUSHP",
        "I1 Required Dip Switch/Control Settings for Step or Variable Components": "I1RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H01 Compressor Frequency/Speed": "H01CompressorFrequencySpeedUSHP",
        "H01 Required Dip Switch/Control Settings for Step or Variable Components": "H01RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H12 Compressor Frequency/Speed": "H12CompressorFrequencySpeedUSHP",
        "H12 Required Dip Switch/Control Settings for Step or Variable Components": "H12RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H11 Compressor Frequency/Speed": "H11CompressorFrequencySpeedUSHP",
        "H11 Required Dip Switch/Control Settings for Step or Variable Components": "H11RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H2V Compressor Frequency/Speed": "H2VCompressorFrequencySpeedUSHP",
        "H2V Required Dip Switch/Control Settings for Step or Variable Components": "H2VRequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H32 Compressor Frequency/Speed": "H32CompressorFrequencySpeedUSHP",
        "H32 Required Dip Switch/Control Settings for Step or Variable Components": "H32RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H0C1 Compressor Frequency/Speed": "H0C1CompressorFrequencySpeedUSHP",
        "H0C1 Required Dip Switch/Control Settings for Step or Variable Components": "H0C1RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H1N Compressor Frequency/Speed": "H1NCompressorFrequencySpeedUSHP",
        "H1N Required Dip Switch/Control Settings for Step or Variable Components": "H1NRequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "H22 Compressor Frequency/Speed": "H22CompressorFrequencySpeedUSHP",
        "H22 Required Dip Switch/Control Settings for Step or Variable Components": "H22RequiredDipSwitchControlSettingsforSteporVariableComponentsUSHP",
        "Enter Any Other Type of Step or Variable Component(s)": "EnterAnyOtherTypeofSteporVariableComponentsUSHP",
        "Air Handler Manufacturer": "AHUMfr",
        "For the Component(s) Identified in the Previous Column, Enter the Required Dip Switch/Control Setting(s) Used for Testing": "FortheComponentsIdentifiedinPreviousColumnDipSwitchControlSettingsforTestingUSHP",
        "Designated Tested Combination": "IsHSVTC",
        "Sold in California": "SoldInCAStateUSHP",
        "Capacity at 105F (Btuh)": "Capacity105F",
        "EER @ 105F": "EER105F",
        "Capacity at 115F (Btuh)": "Capacity115F",
        "EER @ 115": "EER115F",
        "Break-in Period (hrs.)": "BreakIn",
        "Certification Based on Waiver of DOE's Test Procedure Requirements?": "TestWaiverUSHP",
        "Date of Test Procedure Waiver": "TestWaiverDateUSHP",
        "Certification based on Exception Relief granted by DOE's Office?": "ExceptionReliefUSHP",
        "Date of Exception Relief": "ExceptionReliefDateUSHP",
        "Certification based on an Alternate Way of Determining Measures of Energy Conservation?": "AlternateMethodUSHP",
        "AEDM Name or Identifier": "AedmNameUSHP",
        "M1 Certification based on an Alternate Way of Determining Measures of Energy Conservation?": "AlternateMethodM1",
        "M1 AEDM Name or Identifier": "AedmNameM1",
        "Sample Size": "SampleSizeUSHP",
        "M1 Sample Size": "SampleSizeM1",
        "Is basic model engineered-to-order?": "EngToOrderUSHP",
        "Witness test option for DOE": "WitnessOptionDoeUSHP",
        "US Customs and Border Protection importer ID number": "USCustomsBorderIDnumber",
        "Was an Inlet Plenum Installed During Testing?": "WasanInletPlenumInstalledDuringTestingUSHP",
        "Is this an Outdoor Unit with No Match (OUWNM)?": "IsthisanOutdoorUnitwithNoMatchOUWNMUSHP",
        "Number of Tubes High": "NumberofTubesHighUSHP",
        "Number of Tubes Deep": "NumberofTubesDeepUSHP",
        "Does this Central Air Conditioners or Heat Pumps have Two-Capacity Compressors that Lock Out Low Capacity Operation for Cooling at Higher Outdoor Temperatures?": "DoesthisCentralAirConditionersorHeatPumpsforCoolingatHigherOutdoorTemperaturesUSHP",
        "For Central Air Conditioners and Heat Pumps that have Two-Capacity Compressors that Lock Out Low Capacity Operation for Cooling at Higher Outdoor Temperatures, Enter the Outdoor Temperature at Which the Unit Locks Out Low Capacity Operation (Degrees F)": "ForCentralAirConditionersHeatPumpatWhichUnitLocksOutLowCapacityOperationDegreesFUSHP",
        "Does Heat Pump with the two-capacity compressor lock out low capacity operation for heating at lower outdoor temperatures?": "DoesHeatPumpwithtwocapacitycompressorlockoutlowcapacityoperationUSHP",
        "For Heat Pumps that have Two-Capacity Compressors that Lock Out Low Capacity Operation for Heating at Lower Outdoor Temperatures, Enter the Outdoor Temperature at Which the Unit Locks Out Low Capacity Operation (Degrees F)": "ForHeatPumpsthatLockOutLowCapacityOperationatWhichUnitLocksOutLowCapacityOperationDegreesFUSHP",
        "Coil Depth in the Direction of Airflow (Inches)": "CoilDepthintheDirectionofAirflowInchesUSHP",
        "Manufacturer Comments": "MfrCommentsUSHP",
        "Submit to Energy Star": "SubmittoEnergyStar",
        "ENERGY STAR Manufacturing Partner's EPA-issued Organization ID": "ENERGYSTARManufacturingEPAOrgIDUSHP",
        "Partner Contact Name for This Model": "PartnerContactUSHP",
        "Laboratory's EPA-issued Organization ID": "LaboratorysEPAUSHP",
        "Laboratory Contact for this Model": "LaboratoryContactUSHP",
        "Date Available on Market": "DateAvailableonMarketUSHP",
        "In What Markets Is this Model Sold?": "InWhatMarketsIsthisModelSoldUSHP",
        "Cooling Capacity at T1": "CoolingCapacityatT1USHP",
        "Cooling Capacity at T2": "CoolingCapacityatT2USHP",
        "Cooling Capacity at T3": "CoolingCapacityatT3USHP",
        "Cooling Capacity at T4": "CoolingCapacityT4",
        "EER at T1": "EERatT1USHP",
        "EER at T2": "EERatT2USHP",
        "EER at T3": "EERatT3USHP",
        "EER at T4": "EERT4",
        "Heating Capacity at H1": "HeatingCapacityatH1USHP",
        "Heating Capacity at H2": "HeatingCapacityatH2USHP",
        "Heating Capacity at H3": "HeatingCapacityatH3USHP",
        "COP at H1": "COPatH1USHP",
        "COP at H2": "COPatH2USHP",
        "COP at H3": "COPatH3USHP",
        "Extra High Conditions Operability": "ExtraHighConditionsOperabilityUSHP",
        "Publication of Appendix M1 data": "PublicationOfAppendixM1",
        "Date of Appendix M1 publication": "DateOfAppendixM1PublicationM1",
        "Rated Full Load Indoor Coil Air Quantity at T1": "RatedFullLoadIndoorCoilAirQuantityAtT1USHP",
        "Rated Full Load Indoor Coil Air Quantity at T2": "RatedFullLoadIndoorCoilAirQuantityAtT2USHP",
        "Rated Full Load Indoor Coil Air Quantity at T3": "RatedFullLoadIndoorCoilAirQuantityAtT3USHP",
        "Rated Full Load Indoor Coil Air Quantity at T4": "RatedFullLoadIndoorCoilAirQuantityT4",
        "Rated Full Load Indoor Coil Air Quantity at H1": "RatedFullLoadIndoorCoilAirQuantityAtH1USHP",
        "Rated Full Load Indoor Coil Air Quantity at H2": "RatedFullLoadIndoorCoilAirQuantityAtH2USHP",
        "Rated Full Load Indoor Coil Air Quantity at H3": "RatedFullLoadIndoorCoilAirQuantityAtH3USHP",
        "Heating Section Type": "HeatingSectionTypeUSHP",
        "Phase": "CEEPhaseUSACHP",
        "Labeled ENERGY STAR?": "IsEnergyStarApprovedbyAHRI",
        "Footnotes": "Footnotes",
        "Comments": "Comments",
        "In what countries should this record be considered for Path A compliance?": "PathAComplianceCountries",
        "Energy Star Withdrawal Comments": "EnergyStarWithdrawalComments",
        "Discontinued Reason": "DiscontinuedReason",
        "Discontinued Date": "DiscontinuedDate",
        "Location": "LocationName",
        "Is Hidden": "IsHidden",
        "Created Date": "CreatedDate",
        "Created By": "CreatedBy",
        "Modified Date": "ModifiedDate",
        "Modified By": "ModifiedBy",
        "ProductionStop Date": "ProductionStopDate",
        "Is Rerated": "IsRerated",
        "Rerated Date": "ReratedDate",
        "Program": "ProgramName",
        "Company": "CompanyName",
        "Is Approved": "IsApproved",
        "Locked Under EPA Process": "LockedByRole",
        "Outdoor Unit Brand Name": "OutdoorUnitBrandName",
        "Old AHRI Reference Number": "OldRefId",
        "Supplemental PDF": "doeHasPdf",
        "CEE Tier": "ceeTierName",
        "For Which CEE Demand Response Level (according to Section 4.4 Connected Criteria of the CEE Residential Heating and Cooling Systems Initiative) Does the Model Qualify?": "CEEDemandResponseLevel",
        "Reported to DOE?": "doeIsReported",
        "Last Daily DOE Report Date": "doeLastDailyReportDate",
        "Latest DOE Report Action": "doeLastReportAction",
        "Latest CCMS ID": "doeLastCcmsId",
        "Published?": "isPublished",
        "Date Tested": "DateTested",
        "Connected Functionality": "ConnectedFunctionality",
        "Tested Outdoor Model Number": "Tested_Outdoor_ModelNumber",
        "Installation Capabilities": "Installation_Capabilities",
        "Communication Standard - Application Layer": "Comm_Standard_Application",
        "Communication Standard - Media/Network Layer": "Comm_Standard_Media_Ntwrk",
        "Communication Standard - Media/Network Layer Other": "Comm_Standard_Media_Ntwrk_Other",
        "Communication Hardware Architecture": "Comm_Hardware_Architecture",
        "Primary Communication Module/Device Brand Name": "Comm_Device_Brand_Primary",
        "Primary Communication Module/Device Model Number": "Comm_Device_ModelNumber_Primary",
        "Features Enabled By Primary Communication Module/Device": "Comm_Device_FeatureEnbld_Primary",
        "Secondary Communication Module/Device Brand Name": "Comm_Device_Brand_Secondary",
        "Secondary Communication Module/Device Model Number": "Comm_Device_ModelNumber_Secondary",
        "Features Enabled By Secondary Communication Module/Device": "Comm_Device_FeatureEnbld_Secondary",
        "Tertiary Communication Module/Device Brand Name": "Comm_Device_Brand_Tertiary",
        "Tertiary Communication Module/Device Model Number": "Comm_Device_ModelNumber_Tertiary",
        "Features Enabled By Tertiary Communication Module/Device": "Comm_Device_FeatureEnbld_Tertiary",
        "Model Name": "ModelName",
        "Tested Model Name": "Tested_ModelName",
        "Tested Indoor Model Number": "Tested_ModelNumber",
        "ENERGY STAR Cold Climate Designation": "Cold_Climate_Designation",
        "AHRI Reference Number for Equivalent ES Residential Cold Climate Heat Pump": "EquivalentESReferenceNo",
        "Heating Capacity at 17F as calculated by M1": "Heating_Capacity_at_17F_M1",
        "Heating COP at 5F": "Heating_COP_at_5F",
        "Heating COP at 5F as calculated by M1": "Heating_COP_at_5F_M1",
        "Heating Capacity at 5F": "Heating_Capacity_at_5F",
        "Heating Capacity at 5F as calculated by M1": "Heating_Capacity_at_5F_M1",
        "Was DOE 11/30/22 Guidance Used to Calculate 5F data?": "DoeGuidenceUsedFor5f",
        "Was the ENERGY STAR Cold Climate Heat Pump Controls Verification Procedure (CVP) used to confirm 5F data?": "ESColdClimateHeatPumpControlsVerificationProcedure",
        "HSPF2 Region V": "HSPF2_Region_V",
        "Was H4 test conducted?": "HSPF2RegionVWithH4Result",
        "Indoor Heating 5F Air Volume Rate (H4Boost SCFM)": "Indoor_Heating_5F_Air_Volume_Rate_H4Boost_SCFM",
        "H4Boost Compressor Frequency/Speed": "H4Boost_Compressor_Frequency_Speed",
        "H4Boost Required Dip Switch/Control Settings for Step or Variable Components": "H4Boost_Req_Dip_Switch_CTRL_Settings_Step_Var_Components",
        "Old Basic Model Group Id": "oldBasicModelGroupID",
        "Is Broadband Internet Connection Needed for Demand Response?": "IsBroadbandNeeded",
        "Heating 5F to Heating 47F Ratio": "Heating5F_To_Heating47F_Ratio",
        "Heating 5F to Heating 47F Ratio as calculated by M1": "Heating5F_To_Heating47F_Ratio_M1",
        "Refrigerant Type": "RefrigerantTypeCharacteristics",
        "Manufacturer Reference Number": "ManufacturerReferenceNumber",
        "Which Controls Verification Procedures (CVP) were used to confirm 5F data?": "WhichControlsVerificationProceduresUsedFor5FData",
        "For Variable-Speed Coil-Only Systems Only, Is the Represented Value Based on Non-Communicating or Communicating Control?": "VariableSpeedCoilOnlySystemsRepresentedValue",
        "Does the System Vary Blower Speeds with Outdoor Air Conditions?": "DoesSystemVaryBlowerSpeedsWithOutdoorAirConditions",
        "Toff c": "ToffC",
        "Ton c": "TonC",
        "Would you like to submit optional data to DOE for Tax Credit Evaluation?": "SubmitOptionalDataToDOEforTaxCreditEvaluation",
        "Minimum Number of Stages for OEM-Approved Electric Resistance Heat Kits, or Minimum Electric Resistance Heat Stages of Allowed Thermostat Controls, Whichever is Less": "MinimumNumberOfStagesforElectricResistanceKits",
        "Demand Response - Ready HVAC System?": "DemandResponseReadyHVACSystem",
        "Is AHRI 1380 Basic Model?": "IsAHRI1380BasicModel",
        "AHRI 1380 Basic Model Number": "AHRI1380BasicModelNumber",
        "Demand Response-Ready HVAC System Model Number": "DemandResponseReadyHVACSystemModelNumber",
        "Cooling Rated Load Power": "CoolingRatedLoadPower",
        "Heating Rated Load Power": "HeatingRatedLoadPower",
        "Demand Response - Communication Protocol(s) Supported": "DemandResponseCommunicationProtocolSupported",
        "Form Factor Type if CTA-2045-A is the Demand Response - Communication Protocol": "FormFactorTypeIfCTA2045AisDRCommunicationProtocol"
    };

    // PBM Filter Options for USHP
    const pbmFilterOptionsUSHP = {
        'Status': 'ModelStatus',
        'AHRI Certified Reference Number': 'ReferenceId',
        'PBM Outdoor Unit Model Number (Condenser or Single Package)': 'PBMModelNumber',
        'PBM Indoor Unit Model Number (Evaporator and/or Air Handler)': 'PBMCoilModelNumber',
        'Furnace Model Number': 'FurnaceModelNumber',
        'Is Rerated': 'IsRerated',
        'Test Locked': 'IsLocked',
        'Locked Under EPA Process': 'LockedByRole'
    };

    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [validationMessage, setValidationMessage] = useState("");

    const [filterRows, setFilterRows] = useState([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);

    const [programName, setProgramName] = useState(null);
    const [actionType, setActionType] = useState(null);
    const [licenseeType, setLicenseeType] = useState(null);
    const [manufacturerType, setManufacturerType] = useState(null);
    const [licenseeName, setLicenseeName] = useState(null);
    const [location, setLocation] = useState(null);
    const [ahrilicenseeType, setahriLicenseeType] = useState(null);
    const [ahrilicenseeName, setahriLicenseeName] = useState(null);
    const [ahrilocation, setahriLocation] = useState(null);
    const [ahriProgramType, setAhriProgramType] = useState(null);


    const [openComment, setcommnet] = useState(false);
    const [userComment, setuserCommnet] = useState("");
    const [open, setOpen] = useState(false);
    const [uploaddata, setuploaddata] = useState(new FormData());
    const [resetFiles, setresetFiles] = useState(true);
    const [error, setError] = useState(false);

    const [response, setResponse] = useState({
        isSuccess: false,
        Message: null,
        Note: null,
        Loading: true,
    });


    // Handle Licensee Type Change
    const handleLicenseeTypeChange = (event, newValue) => {
        setLicenseeType(newValue);

        if (newValue === "OEM") {
            setLicenseeName("Carrier Corporation");
            setLocation("Indianapolis, IN");
        } else if (newValue === "PBM") {
            setLicenseeName("1Hvac Energy, LLC");
            setLocation(null);
        }
        else {
            setLicenseeName("");
            setLocation("");
        }
    };

    // Handle Licensee Type Change for AHRI Download
    const handleAHRILicenseeTypeChange = (event, newValue) => {
        setahriLicenseeType(newValue);
        setShowFilters(false);
        setFilterRows([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);

        if (newValue === "OEM") {
            setahriLicenseeName("Carrier Corporation");
            setahriLocation("Indianapolis, IN");
        } else if (newValue === "PBM") {
            setahriLicenseeName("1Hvac Energy, LLC");
            setahriLocation(null);
        } else {
            setahriLicenseeName("");
            setahriLocation("");
        }
    };

    // Handle Program Type Change for AHRI Download
    const handleAHRIProgramTypeChange = (event, newValue) => {
        setAhriProgramType(newValue);
        // Reset filters when program type changes
        setShowFilters(false);
        setFilterRows([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);
    };

    // Add new filter row
    const handleAddFilterRow = () => {
        const newId = filterRows.length > 0 ? Math.max(...filterRows.map(row => row.id)) + 1 : 1;
        setFilterRows([...filterRows, { id: newId, filterName: '', constraintType: '', constraintValue: '' }]);
    };

    // Remove filter row
    const handleRemoveFilterRow = (id) => {
        const updatedRows = filterRows.filter(row => row.id !== id);

        if (updatedRows.length === 0) {
            setShowFilters(false);
            setFilterRows([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);
        } else {
            setFilterRows(updatedRows);
        }
    };

    // Update filter row
    const handleFilterRowChange = (id, field, value) => {
        setFilterRows(filterRows.map(row => 
            row.id === id ? { ...row, [field]: value } : row
        ));
    };

    // Get the appropriate filter dictionary based on program type and licensee type
    const getFilterDictionary = () => {
        if (ahriProgramType === 'USAC') {
            return ahrilicenseeType === 'OEM' ? oemFilterOptionsUSAC : pbmFilterOptionsUSAC;
        } else if (ahriProgramType === 'USHP') {
            return ahrilicenseeType === 'OEM' ? oemFilterOptionsUSHP : pbmFilterOptionsUSHP;
        }
        return {};
    };

    // Get available filter options excluding already selected ones
    const getAvailableFilterOptions = (currentRowId) => {
        const selectedFilters = filterRows
            .filter(row => row.id !== currentRowId && row.filterName)
            .map(row => row.filterName);
        
        // Get keys from the appropriate dictionary based on program type and licensee type
        const filterDict = getFilterDictionary();
        const allOptions = Object.keys(filterDict);
        
        return allOptions.filter(option => !selectedFilters.includes(option));
    };

    const handleAHRIDownload = async () => {
        // Updated to map frontend filter names to backend field names using dictionary values
        const filters = filterRows
            .filter(row => row.filterName && row.constraintType && row.constraintValue)
            .map(row => {
                // Get the backend field name from the appropriate dictionary
                const filterDict = getFilterDictionary();
                const backendFieldName = filterDict[row.filterName];
                
                return {
                    filter_name: backendFieldName,
                    constraint_type: row.constraintType,
                    value: row.constraintValue
                };
            });

        // Always send available export fields for the selected program/licensee.
        // This keeps download columns aligned with frontend mapping updates.
        const exportFields = [...new Set(Object.values(getFilterDictionary()))];
        
        console.log(ahriProgramType, ahrilicenseeType, ahrilicenseeName, ahrilocation, filters)
        
        let missingFields = [];

        if (!ahrilicenseeType) missingFields.push("Licensee Type");
        if (!ahriProgramType) missingFields.push("Program Type");

        if (missingFields.length > 0) {
            setValidationMessage(`Please select: ${missingFields.join(", ")}`);
            setOpenValidationDialog(true);
            return;
        }
        setOpen(true);
        let form_data = new FormData();
        form_data.append("ahrilicenseeType", ahrilicenseeType);
        form_data.append("ahrilicenseeName", ahrilicenseeName);
        form_data.append("ahrilocation", ahrilocation);
        form_data.append("ahriProgramType", ahriProgramType);
        form_data.append("filters", JSON.stringify(filters));
        form_data.append("exportFields", JSON.stringify(exportFields));

        const s3_url = await fetchAPI.post("/download_ahri_data", form_data, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
            },
        });
        
        setResponse({
            Loading: false,
            Message: "Files will be sent via Email !!!",
            isSuccess: false,
            isAlert: true,
        });
        setahriLicenseeName('');
        setahriLicenseeType('');
        setahriLocation('');
        setAhriProgramType(null);
        setShowFilters(false);
        setFilterRows([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);
    }

    const handleSubmit = (event) => {

        let missingFields = [];

        if (!programName) missingFields.push("Program Name");
        if (!manufacturerType) missingFields.push("Manufacturer Type");
        if (!licenseeType) missingFields.push("Licensee Type");
        if (!actionType) missingFields.push("Action Type");
        if (!location) missingFields.push("Location")
        if (missingFields.length > 0) {
            setValidationMessage(`Please select: ${missingFields.join(", ")}`);
            setOpenValidationDialog(true);
            return;
        }
        postFinish({ files: fileObjects });
    };


    const handleCommnetOK = async () => {
        let uplaodpayload;
        setcommnet(false);
        uplaodpayload = uploaddata;

        const selectedOptions = {
            programName: Array.isArray(programName) ? programName.join(", ") : programName || "",
            manufacturerType: Array.isArray(manufacturerType) ? manufacturerType.join(", ") : manufacturerType || "",
            licenseeType: Array.isArray(licenseeType) ? licenseeType.join(", ") : licenseeType || "",
            schemaType: Array.isArray(actionType) ? actionType.join(", ") : actionType || "",
            licenseeName: Array.isArray(licenseeName) ? licenseeName.join(", ") : licenseeName || "",
            location: Array.isArray(location) ? location.join(", ") : location || ""
        };

        console.log(selectedOptions)

        const jsonBlob = new Blob([JSON.stringify(selectedOptions, null, 2)], { type: "application/json" });
        uplaodpayload.append("parameter.json", jsonBlob, "parameter.json");

        const commentBlob = new Blob([userComment], { type: "text/plain" });
        uplaodpayload.append("comment.txt", commentBlob, "comment.txt");

        setOpen(true);
        setResponse({
            Loading: true,
            Message: "Please wait, Files are Uploading !!!",
            isSuccess: false,
            isAlert: false,
        });

        let prefix = { prefix: "uploaded_ahri_files" };
        console.log(prefix)
        const s3_url = await fetchAPI.post("/geturl", prefix, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
            },
        });
        console.log(s3_url);

        const zip = new JSZip();
        for (var value of uplaodpayload.values()) {
            console.log(value.name, value);
            zip.file(value.name, value);
        }

        zip.generateAsync({ type: "blob" }).then((content) => {
            let new_data = new FormData();
            Object.keys(s3_url.data.fields).forEach((key) => {
                new_data.append(key, s3_url.data.fields[key]);
            });
            new_data.append("file", content);
            axios
                .post(s3_url.data.url, new_data, {
                    headers: {
                        "Content-type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    console.log(
                        "files uploaded successfully...................................."
                    );
                    setresetFiles(false);
                    setfileObjects([]);
                    updatedefaultvalues();
                    console.log("stauts from main-----");
                    setOpen(false);
                });
        });

        setuserCommnet("");
    };

    const handleCommnetCancel = () => {
        setcommnet(false);
        setOpen(false);
        setuserCommnet("");
    };

    const postFinish = () => {
        if (fileObjects.length > 0) {
            let accepted_files = [
                ".csv"
            ];
            let missing_files = [];

            const data = new FormData();
            for (var i = 0; i < fileObjects.length; i++) {
                let file_name = fileObjects[i].file.name;
                let ismatching = false;
                for (var j = 0; j < accepted_files.length; j++) {
                    if (
                        file_name.toLowerCase().indexOf(accepted_files[j].toLowerCase()) !=
                        -1
                    ) {
                        ismatching = true;
                    }
                }
                if (!ismatching) {
                    missing_files.push(fileObjects[i].file.name);
                }
            }

            if (missing_files.length > 0) {
                setOpen(true);

                setResponse({
                    Loading: false,
                    Message: "Invalid filenames: " + missing_files.join(", ") + ".",
                    Note:
                        "Valid file names should start with: " + accepted_files.join(", "),
                    isSuccess: false,
                    isAlert: true,
                });
                return "";
            }

            for (var i = 0; i < fileObjects.length; i++) {
                data.append(fileObjects[i].file.name, fileObjects[i].file);
            }
            setuploaddata(data);
            setcommnet(true);
        } else {
            setResponse({
                Loading: false,
                Message: "Please uploade a file(s) !!!",
                isSuccess: false,
                isAlert: true,
            });
        }
    };

    const updatedefaultvalues = (event) => {
        setOpen(false);
        setresetFiles(false);
        setfileObjects([]);
        setProgramName([]);
        setActionType([]);
        setLicenseeType([]);
        setManufacturerType([]);
        setLicenseeName([]);
        setLocation([]);
    };
    
    const handledefaultvalues = (event) => {
        setOpen(false);
    };

    useEffect(() => {
        setfileObjects([]);
    }, [resetFiles]);

    // Check if download button should be enabled
    const isDownloadEnabled = ahriProgramType && ahrilicenseeType;

    return (
        <React.Fragment>
            <CssBaseline />
            <Card className={classes.card}>
                <Header position="static" className={classes.appbar} username={username} flag={isSalesGroup} />

                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh', margin: 0, padding: 0, overflowX: 'hidden' }}>
                    <CardContent>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                <Typography variant="h6" className={classes.btn}>Upload AHRI File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container className={classes.rootgrid}>
                                    <Grid item xs={12}>
                                        <div align="center">
                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                <Autocomplete
                                                    className={classes.inputControl}
                                                    disableCloseOnSelect
                                                    id="programName"
                                                    options={programOptions}
                                                    value={programName}
                                                    getOptionLabel={(option) => option}
                                                    onChange={(event, newValue) => setProgramName(newValue)}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" label="Program Name" placeholder="Select Program Name" fullWidth />}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                <Autocomplete
                                                    className={classes.inputControl}
                                                    disableCloseOnSelect
                                                    id="manufacturerType"
                                                    options={manufacturerOptions}
                                                    value={manufacturerType}
                                                    getOptionLabel={(option) => option}
                                                    onChange={(event, newValue) => setManufacturerType(newValue)}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" label="Manufacturer Type" placeholder="Select Manufacturer Type" fullWidth />}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                <Autocomplete
                                                    className={classes.inputControl}
                                                    disableCloseOnSelect
                                                    id="licenseeType"
                                                    options={licenseeOptions}
                                                    value={licenseeType}
                                                    getOptionLabel={(option) => option}
                                                    onChange={handleLicenseeTypeChange}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" label="Licensee Type" placeholder="Select Licensee Type" fullWidth />}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                <Autocomplete
                                                    className={classes.inputControl}
                                                    disableCloseOnSelect
                                                    id="actionType"
                                                    options={actionOptions}
                                                    value={actionType}
                                                    getOptionLabel={(option) => option}
                                                    onChange={(event, newValue) => setActionType(newValue)}
                                                    renderInput={(params) => <TextField {...params} variant="outlined" label="Action Type" placeholder="Select Action Type" fullWidth />}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                <TextField
                                                    className={classes.inputControl}
                                                    id="licenseeName"
                                                    value={licenseeName || ""}
                                                    label="Licensee Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                {licenseeType === "PBM" ? (
                                                    <TextField
                                                        className={classes.inputControl}
                                                        id="location"
                                                        value={location || ""}
                                                        onChange={(event) => setLocation(event.target.value)}
                                                        label="Location"
                                                        variant="outlined"
                                                        placeholder="Enter Location"
                                                        fullWidth
                                                    />
                                                ) : (
                                                    <TextField
                                                        className={classes.inputControl}
                                                        id="location"
                                                        value={location || ""}
                                                        label="Location"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                    />
                                                )}
                                            </FormControl>
                                        </div>

                                        <Dialog open={openValidationDialog} onClose={() => setOpenValidationDialog(false)}>
                                            <DialogTitle>Validation Error</DialogTitle>
                                            <DialogContent>
                                                <Typography color="error">{validationMessage}</Typography>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setOpenValidationDialog(false)} color="primary">OK</Button>
                                            </DialogActions>
                                        </Dialog>
                                        <div className={'panel ' + classes.uploadpanel}>
                                            <div className={'information-box ' + classes.uploadBox}>
                                                <Typography variant="h6" className={classes.btn}>Upload CSV File</Typography>
                                                <Drop css={classes.dropzonearea} files={fileObjects} setfiles={setfileObjects} setfilelimit={1} />
                                                <p style={{ color: 'red', font: 'small-caption' }}>
                                                    * Files are allowed which end with '.csv'
                                                </p>

                                                <div align="center">
                                                    <Button type="button" variant="contained" color="primary" className={classes.submit}
                                                        onClick={handleSubmit}
                                                    >
                                                        Upload
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <div style={{ marginTop: "10px" }}></div>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                <Typography variant="h6" className={classes.btn}>Download AHRI File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container className={classes.rootgrid}>
                                    <Grid item xs={12}>
                                        <div align="center">
                                            <div style={{ position: 'relative', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                                                <FormControl variant="outlined" style={{ width: '22%', minWidth: '200px' }}>
                                                    <Autocomplete
                                                        className={classes.inputControl}
                                                        disableCloseOnSelect
                                                        id="ahrilicenseeType"
                                                        options={licenseeOptions}
                                                        value={ahrilicenseeType}
                                                        getOptionLabel={(option) => option}
                                                        onChange={handleAHRILicenseeTypeChange}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" label="Licensee Type" placeholder="Select Licensee Type" fullWidth />}
                                                    />
                                                </FormControl>

                                                <FormControl variant="outlined" style={{ width: '22%', minWidth: '200px' }}>
                                                    <TextField
                                                        className={classes.inputControl}
                                                        id="ahrilicenseeName"
                                                        value={ahrilicenseeName || ""}
                                                        label="Licensee Name"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                    />
                                                </FormControl>

                                                <FormControl variant="outlined" style={{ width: '22%', minWidth: '200px' }}>
                                                    {ahrilicenseeType === "PBM" ? (
                                                        <TextField
                                                            className={classes.inputControl}
                                                            id="ahrilocation"
                                                            value={ahrilocation || ""}
                                                            onChange={(event) => setahriLocation(event.target.value)}
                                                            label="Location"
                                                            variant="outlined"
                                                            placeholder="Enter Location"
                                                            fullWidth
                                                        />
                                                    ) : (
                                                        <TextField
                                                            className={classes.inputControl}
                                                            id="ahrilocation"
                                                            value={ahrilocation || ""}
                                                            label="Location"
                                                            variant="outlined"
                                                            fullWidth
                                                            disabled
                                                        />
                                                    )}
                                                </FormControl>

                                                <FormControl variant="outlined" style={{ width: '22%', minWidth: '200px' }}>
                                                    <Autocomplete
                                                        className={classes.inputControl}
                                                        disableCloseOnSelect
                                                        id="ahriProgramType"
                                                        options={programTypeOptions}
                                                        value={ahriProgramType}
                                                        getOptionLabel={(option) => option}
                                                        onChange={handleAHRIProgramTypeChange}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" label="Program Type" placeholder="Select Program Type" fullWidth />}
                                                    />
                                                </FormControl>

                                                {ahrilicenseeType && ahriProgramType && (
                                                    <div style={{ position: 'absolute', right: '-50px', top: '50%', transform: 'translateY(-50%)' }}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => {
                                                                if (!showFilters) {
                                                                    setShowFilters(true);
                                                                    setFilterRows([{ id: 1, filterName: '', constraintType: '', constraintValue: '' }]);
                                                                } else {
                                                                    handleAddFilterRow();
                                                                }
                                                            }}
                                                            style={{ minWidth: '40px', maxWidth: '40px', padding: '8px', height: '40px' }}
                                                        >
                                                            <AddIcon />
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Dynamic Filter Rows */}
                                        {showFilters && filterRows.map((row, index) => (
                                            <div key={row.id} style={{ position: 'relative', marginBottom: '10px', marginTop: '10px' }}>
                                                <div align="center">
                                                    <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                        <Autocomplete
                                                            className={classes.inputControl}
                                                            id={`filterName_${row.id}`}
                                                            options={getAvailableFilterOptions(row.id)}
                                                            value={row.filterName}
                                                            onChange={(event, newValue) => handleFilterRowChange(row.id, 'filterName', newValue)}
                                                            renderInput={(params) => <TextField {...params} variant="outlined" label="Filter Name" placeholder="Select Filter" />}
                                                        />
                                                    </FormControl>

                                                    <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                        <Autocomplete
                                                            className={classes.inputControl}
                                                            id={`constraintType_${row.id}`}
                                                            options={constraintTypeOptions}
                                                            value={row.constraintType}
                                                            onChange={(event, newValue) => handleFilterRowChange(row.id, 'constraintType', newValue)}
                                                            renderInput={(params) => <TextField {...params} variant="outlined" label="Constraint Type" placeholder="Select Constraint" />}
                                                        />
                                                    </FormControl>

                                                    <FormControl variant="outlined" className={classes.selectformControl_ahri}>
                                                        <TextField
                                                            className={classes.inputControl}
                                                            id={`constraintValue_${row.id}`}
                                                            value={row.constraintValue}
                                                            onChange={(event) => handleFilterRowChange(row.id, 'constraintValue', event.target.value)}
                                                            label="Constraint Value"
                                                            variant="outlined"
                                                            placeholder="Enter Constraint Value"
                                                            fullWidth
                                                        />
                                                    </FormControl>
                                                </div>

                                                <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => handleRemoveFilterRow(row.id)}
                                                        style={{ minWidth: '40px', maxWidth: '40px', padding: '8px', height: '40px' }}
                                                    >
                                                        <RemoveIcon />
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}

                                        <Dialog open={openValidationDialog} onClose={() => setOpenValidationDialog(false)}>
                                            <DialogTitle>Validation Error</DialogTitle>
                                            <DialogContent>
                                                <Typography color="error">{validationMessage}</Typography>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setOpenValidationDialog(false)} color="primary">OK</Button>
                                            </DialogActions>
                                        </Dialog>
                                        <div className={'panel ' + classes.uploadpanel}>
                                            <div className={'information-box ' + classes.uploadBox}>
                                                <div align="center">
                                                    <Button 
                                                        type="button" 
                                                        variant="contained" 
                                                        color="primary" 
                                                        className={classes.submit}
                                                        onClick={handleAHRIDownload}
                                                        disabled={!isDownloadEnabled}
                                                        style={{
                                                            backgroundColor: isDownloadEnabled ? undefined : '#cccccc',
                                                            color: isDownloadEnabled ? undefined : '#666666',
                                                            cursor: isDownloadEnabled ? 'pointer' : 'not-allowed'
                                                        }}
                                                    >
                                                        Download
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <div>
                            <Grid>
                                <React.Fragment>
                                    <Dialog disableEscapeKeyDown={false} open={open}>
                                        <DialogContent>
                                            {response.Loading && (
                                                <CircularProgress></CircularProgress>
                                            )}
                                            <Typography
                                                variant="h6"
                                                color="primary"
                                                style={{ whiteSpace: "pre-wrap" }}
                                            >
                                                {response.Message}
                                            </Typography>
                                            <Typography
                                                style={{ color: "red", font: "small-caption" }}
                                            >
                                                {response.Note}
                                            </Typography>
                                        </DialogContent>
                                        {response.isSuccess && !response.isAlert && (
                                            <DialogActions>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={updatedefaultvalues}
                                                >
                                                    Ok
                                                </Button>
                                            </DialogActions>
                                        )}
                                        {response.isAlert && (
                                            <DialogActions>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={handledefaultvalues}
                                                >
                                                    Ok
                                                </Button>
                                            </DialogActions>
                                        )}
                                    </Dialog>
                                    <Dialog disableEscapeKeyDown={false} open={openComment}>
                                        <DialogTitle>
                                            <Typography
                                                component="span"
                                                variant="h6"
                                                color="primary"
                                                style={{ whiteSpace: "pre-wrap" }}
                                            >
                                                Comments
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <Typography
                                                variant="subtitle1"
                                                color="primary"
                                                style={{ whiteSpace: "pre-wrap" }}
                                            >
                                                <TextField
                                                    onChange={(e) => setuserCommnet(e.target.value)}
                                                    autoFocus
                                                    fullWidth
                                                    placeholder="Your comments"
                                                />
                                            </Typography>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                disabled={userComment.length < 1}
                                                onClick={handleCommnetOK}
                                            >
                                                OK
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleCommnetCancel}
                                            >
                                                Cancel
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </React.Fragment>
                            </Grid>
                        </div>

                    </CardContent>
                </Box>
            </Card>
        </React.Fragment >
    );
};

export default AhriUpload;
